import React from 'react';
import { productShortName } from '../data/offer';
export function Footer() {
  return <footer className="bg-background text-muted/80" data-id="element-70" data-mp="3gezdb400vr15">
      <div className="h-1 w-full bg-primary shadow-[0_0_16px_rgba(0,200,248,0.8)]" aria-hidden="true" data-id="element-71" data-mp="3ggu1qsai619z" />
      <div className="mx-auto max-w-3xl px-4 py-8 text-center" data-id="element-72" data-mp="32pp764lzrz6i">
        <p className="text-xs" data-id="element-73" data-mp="36oo5h6d7wxoz">© 2026 {productShortName} — All rights reserved.</p>
      </div>
    </footer>;
}